/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import CityInput, { CityInputProps } from '../inputs/CityInput'
import { parseNumber } from '@jalik/form-parser'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function CityField (props: FormTextFieldProps & Partial<CityInputProps>) {
  const { name = 'cityId', ...others } = props
  return (
    <FormField
      {...others}
      render={CityInput}
      name={name}
      parser={parseNumber}
    />
  )
}

export default CityField
